import { useState } from 'react';

import { PROTOCOL, TChannelProtocol } from '@/entities/channel';
import { Box } from '@/shared/ui';
import { SvgIcon } from '@/shared/ui/SvgIcon';

import { PROTOCOL_TO_LOGO } from '../model/constants';

type ChannelIconByTypeProps = {
  type: TChannelProtocol;
  avatarUrl?: string;
};

export const ChannelIconByType = ({ type, avatarUrl }: ChannelIconByTypeProps) => {
  const [failedAvatarUrl, setFailedAvatarUrl] = useState<string | null>(null);
  const showAvatar =
    type !== PROTOCOL.MAX &&
    type !== PROTOCOL.MAX_PERSONAL &&
    avatarUrl &&
    failedAvatarUrl !== avatarUrl;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {showAvatar ? (
        <Box
          component="img"
          src={avatarUrl}
          alt=""
          onError={() => setFailedAvatarUrl(avatarUrl ?? null)}
          sx={{
            width: 24,
            height: 24,
            flexShrink: 0,
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      ) : (
        <SvgIcon name={PROTOCOL_TO_LOGO[type]} />
      )}
    </Box>
  );
};
